import auth from '@/middlewares/auth'
import autoLogin  from '@/middlewares/autoLogin'
import routerName from '@/constants/routers'

export default [
	{
        path: '/preloading',
        name: routerName.PRELOADING,
        meta : {
            middleware : [ autoLogin , auth ],
            breadcrumb: [
                { name: 'Preloading' }
            ]
        },
        component: () => import( /* webpackChunkName: "preloading" */ './views/index.vue')
    }
]